<div class="app-loading bg-[#fff] fixed top-0 left-0 right-0 bottom-0 w-screen h-screen z-[9999999]">
    <div class="logo">
      <img src="assets/logo.svg" alt="BDO mobile" height="100" width="100" />
    </div>
    <svg class="spinner" viewBox="25 25 50 50">
      <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/>
    </svg>
  </div>
  